import {Injectable} from '@angular/core';

import {AbstractContainer} from '../util/abstract-container.service';

/**
 * Service that contains an application's disclaimer
 */
@Injectable({providedIn: 'root'})
export class ApplicationDisclaimerContainer extends AbstractContainer {}
